/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InStoreOrdersQueryVariables = Types.Exact<{
  input: Types.InStoreOrdersInput;
}>;

export type InStoreOrdersQuery = {
  readonly __typename?: 'Query';
  readonly inStoreLoyaltyOrders: {
    readonly __typename: 'InStoreOrdersResponse';
    readonly pagination: {
      readonly __typename?: 'Pagination';
      readonly total: number;
      readonly last: number;
    };
    readonly inStoreOrders: ReadonlyArray<{
      readonly __typename: 'InStoreOrder';
      readonly id: string;
      readonly wantedTime: string;
      readonly isPendingFeedback: boolean;
      readonly orderStatus: string;
      readonly ledger: {
        readonly __typename: 'InStoreOrderLedger';
        readonly subtotal: number;
        readonly tax: number;
        readonly tip: number;
        readonly total: number;
        readonly discounts: ReadonlyArray<{
          readonly __typename: 'InStoreOrderDiscount';
          readonly amount: number;
          readonly isLoyalty: boolean;
          readonly name: string;
        }>;
        readonly payments: ReadonlyArray<{
          readonly __typename: 'InStoreOrderPayment';
          readonly amount: number;
          readonly type: string;
        }>;
      };
      readonly lineItems: ReadonlyArray<{
        readonly __typename: 'InStoreOrderLineItem';
        readonly brinkId: string;
        readonly price: number;
        readonly quantity: number;
        readonly name: string;
        readonly asset: {
          readonly __typename?: 'InStoreOrderLineItemAsset';
          readonly url: string;
        };
      }>;
      readonly restaurant: {
        readonly __typename: 'InStoreOrderRestaurant';
        readonly entityId: string;
        readonly name: string;
      };
    }>;
  };
};

export const InStoreOrdersDocument = gql`
  query InStoreOrders($input: InStoreOrdersInput!) {
    inStoreLoyaltyOrders(input: $input) {
      __typename
      ... on InStoreOrdersResponse {
        pagination {
          total
          last
        }
        inStoreOrders {
          __typename
          id
          wantedTime
          isPendingFeedback
          orderStatus
          ledger {
            __typename
            subtotal
            tax
            tip
            total
            discounts {
              __typename
              amount
              isLoyalty
              name
            }
            payments {
              __typename
              amount
              type
            }
          }
          lineItems {
            __typename
            brinkId
            price
            quantity
            name
            asset {
              url
            }
          }
          restaurant {
            __typename
            entityId
            name
          }
        }
      }
    }
  }
`;

export function useInStoreOrdersQuery(
  options: Omit<Urql.UseQueryArgs<InStoreOrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<InStoreOrdersQuery, InStoreOrdersQueryVariables>({
    query: InStoreOrdersDocument,
    ...options,
  });
}
